<br>
  @if (!showStarRatingRequest || !fiveStarReviewLink) {
    <form id="surveyForm" #surveyForm="ngForm">
      @if (surveyHeader) {
        <div class="p-grid">
          @for (answer of surveyHeader.surveyAnswers; track trackByIndex(i, answer); let i = $index) {
            <div class="ui-g-12">
              @if (answer.surveyQuestion.visible) {
                @if (answer.surveyQuestion.isYesNo) {
                  <h6>{{answer.surveyQuestion.question}}</h6>
                  <span style="margin-left: .5em">
                    <p-radiobutton [name]="'yesNoGroup' + i" [value]="true" label="Yes"
                      [(ngModel)]="surveyHeader.surveyAnswers[i].yesNoResponse" inputId="opt1" [disabled]="completed">
                    </p-radiobutton>
                  </span>
                  <span style="margin-left: .5em">
                    <p-radiobutton [name]="'yesNoGroup' + i" [value]="false" label="No"
                      [(ngModel)]="surveyHeader.surveyAnswers[i].yesNoResponse" inputId="opt2" [disabled]="completed">
                    </p-radiobutton>
                  </span>
                }
                @if (!answer.surveyQuestion.isYesNo) {
                  <h6>{{answer.surveyQuestion.question}}</h6>
                  <textarea pInputTextarea [name]="'comment' + i" [(ngModel)]="surveyHeader.surveyAnswers[i].comment"
                  [disabled]="completed"></textarea>
                }
              }
            </div>
          }
          <div class="ui-g-12 columnPadding">
            @if (errorsInForm) {
              <div class="alert alert-danger" role="alert">
                Please complete all yes/no questions.
              </div>
            }
          </div>
          <div class="ui-g-12">
            @if (!completed) {
              <p-button type="submit" severity="success"  
                (click)="submit()" label="Submit">
              </p-button>
            }
            @if (!completed) {
              <p-button type="button" severity="secondary" 
                (click)="cancel()" label="Cancel">
              </p-button>
            }
            @if (completed && !isCustomer) {
              <p-button type="button" severity="danger"
                (click)="goToSurveyList()" label="Return to List">
              </p-button>
            }
          </div>
        </div>
      }
    </form>
  }

  @if (showStarRatingRequest && fiveStarReviewLink) {
    <div>
      Thank you for taking the time to complete our quick 1-minute survey! If you have a moment, we would greatly appreciate it if you could also leave us a <a href="http://russelltreeexperts.com/google">5-star review on Google</a>! It can go a long way with helping our local business! Thank you!
    </div>
  }